const colors = require('./styles/tokens/colors.js');
const colorsDD = require('./styles/tokens/colors-dd.js');
const typographies = require('./styles/tokens/typographies.js');
const typographiesDD = require('./styles/tokens/typographies-dd.js');

const containerPadding = {
  DEFAULT: '1.7rem',
  sm: '1.7rem',
  md: '3rem',
  lg: '4rem',
  xl: '4rem',
  '2xl': '4rem',
};

const containerPaddingDD = {
  DEFAULT: '30px',
  sm: '30px',
  md: '3rem',
  lg: '4rem',
  xl: '4rem',
  '2xl': '4rem',
};

module.exports = {
  content: [
    './pages/**/*.{js,ts,jsx,tsx}',
    './components/**/*.{js,ts,jsx,tsx}',
  ],
  theme: {
    extend: {
      margin: {
        '1/3': '30%',
      },
      opacity: {
        15: '.15',
      },
      height: {
        screen: ['100vh /* fallback for Opera, IE and etc. */', '100dvh'],
      },
    },
  },
  plugins: [
    require('tailwindcss-themer')({
      defaultTheme: {
        extend: {
          container: {
            padding: containerPadding,
          },
          keyframes: {
            'fade-in': {
              '0%': {
                opacity: '0',
              },
              '100%': {
                opacity: '1',
              },
            },
          },
          animation: {
            'fade-in': 'fade-in 0.7s ease-in-out',
          },
          colors,
          borderWidth: {
            DEFAULT: '1px',
            1: '1px',
          },
          borderRadius: {
            button: '100px',
          },
          fontFamily: {
            sans: ['Roboto'],
            serif: ['NB International Pro'],
          },
          gridTemplateColumns: {
            'content-grid-overflow-x': 'repeat(4, minmax(286px, 1fr))',
          },
          spacing: {
            half: '768px',
            wide: '1536px',
          },
          maxWidth: {
            half: '768px',
            wide: '1536px',
          },
          fontFamily: {
            text: ['NB International Pro', 'sans-serif'],
            heading: ['NB International Pro', 'sans-serif'],
            sans: ['Roboto', 'sans-serif'],
            serif: ['NB International Pro', 'sans-serif'],
            arial: ['Arial'],
            'body-neue': ['Neue Haas Unica Pro', 'sans-serif'],
            'pro-mono': ['NB International Pro Mono', 'sans-serif'],
          },
          fontWeight: {
            h1: typographies['d-h1'].fontWeight,
            'h1-mobile': typographies['m-h1'].fontWeight,
            h2: typographies['d-h2'].fontWeight,
            'h2-mobile': typographies['m-h2'].fontWeight,
            h3: typographies['d-h3'].fontWeight,
            'h3-mobile': typographies['m-h3'].fontWeight,
            h4: typographies['d-h4'].fontWeight,
            'h4-mobile': typographies['m-h4'].fontWeight,
            h5: typographies['d-h5'].fontWeight,
            'h5-mobile': typographies['m-h5'].fontWeight,
            h6: typographies['d-h6'].fontWeight,
            'h6-mobile': typographies['m-h6'].fontWeight,
            body: typographies['body-text'].fontWeight,
            'body-bold': typographies['body-text-bold'].fontWeight,
            'body-large': typographies['body-text-large'].fontWeight,
            'body-large-bold': typographies['body-text-large-bold'].fontWeight,
            button: typographies['button-and-tag-text'].fontWeight,
            tag: typographies['button-and-tag-text'].fontWeight,
            caption: typographies['caption-text'].fontWeight,
          },
          fontSize: {
            h1: [
              typographies['d-h1'].fontSize,
              {
                lineHeight: typographies['d-h1'].lineHeight,
                letterSpacing: typographies['d-h1'].letterSpacing,
              },
            ],
            'h1-mobile': [
              typographies['m-h1'].fontSize,
              {
                lineHeight: typographies['m-h1'].lineHeight,
                letterSpacing: typographies['m-h1'].letterSpacing,
              },
            ],
            h2: [
              typographies['d-h2'].fontSize,
              {
                lineHeight: typographies['d-h2'].lineHeight,
                letterSpacing: typographies['d-h2'].letterSpacing,
              },
            ],
            'h2-mobile': [
              typographies['m-h2'].fontSize,
              {
                lineHeight: typographies['m-h2'].lineHeight,
                letterSpacing: typographies['m-h2'].letterSpacing,
              },
            ],
            h3: [
              typographies['d-h3'].fontSize,
              {
                lineHeight: typographies['d-h3'].lineHeight,
                letterSpacing: typographies['d-h3'].letterSpacing,
              },
            ],
            'h3-mobile': [
              typographies['m-h3'].fontSize,
              {
                lineHeight: typographies['m-h3'].lineHeight,
                letterSpacing: typographies['m-h3'].letterSpacing,
              },
            ],
            h4: [
              typographies['d-h4'].fontSize,
              {
                lineHeight: typographies['d-h4'].lineHeight,
                letterSpacing: typographies['d-h4'].letterSpacing,
              },
            ],
            'h4-mobile': [
              typographies['m-h4'].fontSize,
              {
                lineHeight: typographies['m-h4'].lineHeight,
                letterSpacing: typographies['m-h4'].letterSpacing,
              },
            ],
            h5: [
              typographies['d-h5'].fontSize,
              {
                lineHeight: typographies['d-h5'].lineHeight,
                letterSpacing: typographies['d-h5'].letterSpacing,
              },
            ],
            'h5-mobile': [
              typographies['m-h5'].fontSize,
              {
                lineHeight: typographies['m-h5'].lineHeight,
                letterSpacing: typographies['m-h5'].letterSpacing,
              },
            ],
            h6: [
              typographies['d-h6'].fontSize,
              {
                lineHeight: typographies['d-h6'].lineHeight,
                letterSpacing: typographies['d-h6'].letterSpacing,
              },
            ],
            'h6-mobile': [
              typographies['m-h6'].fontSize,
              {
                lineHeight: typographies['m-h6'].lineHeight,
                letterSpacing: typographies['m-h6'].letterSpacing,
              },
            ],
            body: [
              typographies['body-text'].fontSize,
              {
                lineHeight: typographies['body-text'].lineHeight,
                letterSpacing: typographies['body-text'].letterSpacing,
              },
            ],
            'body-bold': [
              typographies['body-text-bold'].fontSize,
              {
                lineHeight: typographies['body-text-bold'].lineHeight,
                letterSpacing: typographies['body-text-bold'].letterSpacing,
              },
            ],
            'body-large': [
              typographies['body-text-large'].fontSize,
              {
                lineHeight: typographies['body-text-large'].lineHeight,
                letterSpacing: typographies['body-text-large'].letterSpacing,
              },
            ],
            'body-large-bold': [
              typographies['body-text-large-bold'].fontSize,
              {
                lineHeight: typographies['body-text-large-bold'].lineHeight,
                letterSpacing:
                  typographies['body-text-large-bold'].letterSpacing,
              },
            ],
            button: [
              typographies['button-and-tag-text'].fontSize,
              {
                lineHeight: typographies['button-and-tag-text'].lineHeight,
                letterSpacing:
                  typographies['button-and-tag-text'].letterSpacing,
              },
            ],
            tag: [
              typographies['button-and-tag-text'].fontSize,
              {
                lineHeight: typographies['button-and-tag-text'].lineHeight,
                letterSpacing:
                  typographies['button-and-tag-text'].letterSpacing,
              },
            ],
            caption: [
              typographies['caption-text'].fontSize,
              {
                lineHeight: typographies['caption-text'].lineHeight,
                letterSpacing: typographies['caption-text'].letterSpacing,
              },
            ],
            tiny: '9px',
          },
          boxShadow: {
            'back-to-top': '0px 4px 8px 0px rgba(0, 0, 0, 0.20)',
            'input-form': '0px 1px 0px 0px #CECECE',
            'input-form-active': '0px 2px 0px 0px #838D75',
          },
        },
      },
      themes: [
        {
          name: 'dd-kr',
          extend: {
            backgroundImage: {
              'quality-gold':
                'linear-gradient(315deg, #9D815B 0%, #B09471 43.23%, #E5C794 100%)',
            },
            colors: {
              ...colorsDD,
              'button-gold-hover': '#8c745cff',
              'grey-dd': '#DDDDDD',
              'progressive-blue-40': '#002040',
              'majesty-30-transparent': 'rgba(116, 106, 128, 0.5)',
            },
            container: {
              padding: containerPaddingDD,
            },
            boxShadow: {
              dropdown:
                '0px 71px 29px rgba(0, 0, 0, 0.01), 0px 40px 24px rgba(0, 0, 0, 0.03), 0px 18px 18px rgba(0, 0, 0, 0.04), 0px 4px 10px rgba(0, 0, 0, 0.05), 0px 0px 0px rgba(0, 0, 0, 0.05)',
            },
            fontFamily: {
              text: ['Noto Sans KR', 'sans-serif'],
              heading: ['Godo B', 'sans-serif'],
            },
            fontWeight: {
              h1: typographiesDD['d-heading-1-kor'].fontWeight,
              'h1-mobile': typographiesDD['m-heading-1-kor'].fontWeight,
              h2: typographiesDD['d-heading-2-kor'].fontWeight,
              'h2-mobile': typographiesDD['m-heading-2-kor'].fontWeight,
              h3: typographiesDD['d-heading-3-kor'].fontWeight,
              'h3-mobile': typographiesDD['m-heading-3-kor'].fontWeight,
              h4: typographiesDD['d-heading-4-kor'].fontWeight,
              'h4-mobile': typographiesDD['m-heading-4-kor'].fontWeight,
              h5: typographiesDD['d-heading-5-kor'].fontWeight,
              'h5-mobile': typographiesDD['m-heading-5-kor'].fontWeight,
              h6: typographiesDD['d-heading-6-kor'].fontWeight,
              'h6-mobile': typographiesDD['m-heading-6-kor'].fontWeight,
              body: typographiesDD['body-text-kor'].fontWeight,
              'body-bold': typographiesDD['body-text-bold-kor'].fontWeight,
              'body-large': typographiesDD['body-text-large-kor'].fontWeight,
              'body-large-bold':
                typographiesDD['body-text-large-bold-kor'].fontWeight,
              button: typographiesDD['button-text-kor'].fontWeight,
              tag: typographiesDD['button-text-kor'].fontWeight,
              small: typographiesDD['small-text-kor'].fontWeight,
              'small-bold': typographiesDD['small-text-bold-kor'].fontWeight,
              subheading: typographiesDD['sub-heading-kor'].fontWeight,
              'subheading-mobile':
                typographiesDD['m-sub-heading-kor'].fontWeight,
            },
            fontSize: {
              h1: [
                typographiesDD['d-heading-1-kor'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-1-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-1-kor'].letterSpacing,
                },
              ],
              'h1-mobile': [
                typographiesDD['m-heading-1-kor'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-1-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-1-kor'].letterSpacing,
                },
              ],
              h2: [
                typographiesDD['d-heading-2-kor'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-2-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-2-kor'].letterSpacing,
                },
              ],
              'h2-mobile': [
                typographiesDD['m-heading-2-kor'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-2-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-2-kor'].letterSpacing,
                },
              ],
              h3: [
                typographiesDD['d-heading-3-kor'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-3-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-3-kor'].letterSpacing,
                },
              ],
              'h3-mobile': [
                typographiesDD['m-heading-3-kor'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-3-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-3-kor'].letterSpacing,
                },
              ],
              h4: [
                typographiesDD['d-heading-4-kor'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-4-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-4-kor'].letterSpacing,
                },
              ],
              'h4-mobile': [
                typographiesDD['m-heading-4-kor'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-4-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-4-kor'].letterSpacing,
                },
              ],
              h5: [
                typographiesDD['d-heading-5-kor'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-5-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-5-kor'].letterSpacing,
                },
              ],
              'h5-mobile': [
                typographiesDD['m-heading-5-kor'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-5-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-5-kor'].letterSpacing,
                },
              ],
              h6: [
                typographiesDD['d-heading-6-kor'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-6-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-6-kor'].letterSpacing,
                },
              ],
              'h6-mobile': [
                typographiesDD['m-heading-6-kor'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-6-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-6-kor'].letterSpacing,
                },
              ],
              body: [
                typographiesDD['body-text-kor'].fontSize,
                {
                  lineHeight: typographiesDD['body-text-kor'].lineHeight,
                  letterSpacing: typographiesDD['body-text-kor'].letterSpacing,
                },
              ],
              'body-bold': [
                typographiesDD['body-text-bold-kor'].fontSize,
                {
                  lineHeight: typographiesDD['body-text-bold-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['body-text-bold-kor'].letterSpacing,
                },
              ],
              'body-large': [
                typographiesDD['body-text-large-kor'].fontSize,
                {
                  lineHeight: typographiesDD['body-text-large-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['body-text-large-kor'].letterSpacing,
                },
              ],
              'body-large-bold': [
                typographiesDD['body-text-large-bold-kor'].fontSize,
                {
                  lineHeight:
                    typographiesDD['body-text-large-bold-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['body-text-large-bold-kor'].letterSpacing,
                },
              ],
              button: [
                typographiesDD['button-text-kor'].fontSize,
                {
                  lineHeight: typographiesDD['button-text-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['button-text-kor'].letterSpacing,
                },
              ],
              tag: [
                typographiesDD['button-text-kor'].fontSize,
                {
                  lineHeight: typographiesDD['button-text-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['button-text-kor'].letterSpacing,
                },
              ],
              small: [
                typographiesDD['small-text-kor'].fontSize,
                {
                  lineHeight: typographiesDD['small-text-kor'].lineHeight,
                  letterSpacing: typographiesDD['small-text-kor'].letterSpacing,
                },
              ],
              'small-bold': [
                typographiesDD['small-text-bold-kor'].fontSize,
                {
                  lineHeight: typographiesDD['small-text-bold-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['small-text-bold-kor'].letterSpacing,
                },
              ],
              subheading: [
                typographiesDD['sub-heading-kor'].fontSize,
                {
                  lineHeight: typographiesDD['sub-heading-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['sub-heading-kor'].letterSpacing,
                },
              ],
              'subheading-mobile': [
                typographiesDD['m-sub-heading-kor'].fontSize,
                {
                  lineHeight: typographiesDD['m-sub-heading-kor'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-sub-heading-kor'].letterSpacing,
                },
              ],
            },
          },
        },
        {
          name: 'dd-en',
          extend: {
            backgroundImage: {
              'quality-gold':
                'linear-gradient(315deg, #9D815B 0%, #B09471 43.23%, #E5C794 100%)',
            },
            colors: {
              ...colorsDD,
              'button-gold-hover': '#8c745cff',
              'grey-dd': '#DDDDDD',
              'progressive-blue-40': '#002040',
              'majesty-30-transparent': 'rgba(116, 106, 128, 0.5)',
            },
            container: {
              padding: containerPaddingDD,
            },
            boxShadow: {
              dropdown:
                '0px 71px 29px rgba(0, 0, 0, 0.01), 0px 40px 24px rgba(0, 0, 0, 0.03), 0px 18px 18px rgba(0, 0, 0, 0.04), 0px 4px 10px rgba(0, 0, 0, 0.05), 0px 0px 0px rgba(0, 0, 0, 0.05)',
            },
            fontFamily: {
              text: ['Noto Sans', 'sans-serif'],
              heading: ['BentonSansCompressed Bold', 'sans-serif'],
            },
            fontWeight: {
              h1: typographiesDD['d-heading-1-eng'].fontWeight,
              'h1-mobile': typographiesDD['m-heading-1-eng'].fontWeight,
              h2: typographiesDD['d-heading-2-eng'].fontWeight,
              'h2-mobile': typographiesDD['m-heading-2-eng'].fontWeight,
              h3: typographiesDD['d-heading-3-eng'].fontWeight,
              'h3-mobile': typographiesDD['m-heading-3-eng'].fontWeight,
              h4: typographiesDD['d-heading-4-eng'].fontWeight,
              'h4-mobile': typographiesDD['m-heading-4-eng'].fontWeight,
              h5: typographiesDD['d-heading-5-eng'].fontWeight,
              'h5-mobile': typographiesDD['m-heading-5-eng'].fontWeight,
              h6: typographiesDD['d-heading-6-eng'].fontWeight,
              'h6-mobile': typographiesDD['m-heading-6-eng'].fontWeight,
              body: typographiesDD['body-text-eng'].fontWeight,
              button: typographiesDD['button-text-eng'].fontWeight,
              tag: typographiesDD['button-text-eng'].fontWeight,
              small: typographiesDD['small-text-eng'].fontWeight,
              'small-bold': typographiesDD['small-text-bold-eng'].fontWeight,
              subheading: typographiesDD['d-sub-heading-eng'].fontWeight,
              'subheading-mobile':
                typographiesDD['d-sub-heading-eng'].fontWeight,
            },
            fontSize: {
              h1: [
                typographiesDD['d-heading-1-eng'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-1-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-1-eng'].letterSpacing,
                },
              ],
              'h1-mobile': [
                typographiesDD['m-heading-1-eng'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-1-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-1-eng'].letterSpacing,
                },
              ],
              h2: [
                typographiesDD['d-heading-2-eng'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-2-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-2-eng'].letterSpacing,
                },
              ],
              'h2-mobile': [
                typographiesDD['m-heading-2-eng'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-2-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-2-eng'].letterSpacing,
                },
              ],
              h3: [
                typographiesDD['d-heading-3-eng'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-3-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-3-eng'].letterSpacing,
                },
              ],
              'h3-mobile': [
                typographiesDD['m-heading-3-eng'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-3-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-3-eng'].letterSpacing,
                },
              ],
              h4: [
                typographiesDD['d-heading-4-eng'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-4-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-4-eng'].letterSpacing,
                },
              ],
              'h4-mobile': [
                typographiesDD['m-heading-4-eng'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-4-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-4-eng'].letterSpacing,
                },
              ],
              h5: [
                typographiesDD['d-heading-5-eng'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-5-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-5-eng'].letterSpacing,
                },
              ],
              'h5-mobile': [
                typographiesDD['m-heading-5-eng'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-5-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-5-eng'].letterSpacing,
                },
              ],
              h6: [
                typographiesDD['d-heading-6-eng'].fontSize,
                {
                  lineHeight: typographiesDD['d-heading-6-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-heading-6-eng'].letterSpacing,
                },
              ],
              'h6-mobile': [
                typographiesDD['m-heading-6-eng'].fontSize,
                {
                  lineHeight: typographiesDD['m-heading-6-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['m-heading-6-eng'].letterSpacing,
                },
              ],
              body: [
                typographiesDD['body-text-eng'].fontSize,
                {
                  lineHeight: typographiesDD['body-text-eng'].lineHeight,
                  letterSpacing: typographiesDD['body-text-eng'].letterSpacing,
                },
              ],
              button: [
                typographiesDD['button-text-eng'].fontSize,
                {
                  lineHeight: typographiesDD['button-text-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['button-text-eng'].letterSpacing,
                },
              ],
              tag: [
                typographiesDD['button-text-eng'].fontSize,
                {
                  lineHeight: typographiesDD['button-text-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['button-text-eng'].letterSpacing,
                },
              ],
              small: [
                typographiesDD['small-text-eng'].fontSize,
                {
                  lineHeight: typographiesDD['small-text-eng'].lineHeight,
                  letterSpacing: typographiesDD['small-text-eng'].letterSpacing,
                },
              ],
              'small-bold': [
                typographiesDD['small-text-bold-eng'].fontSize,
                {
                  lineHeight: typographiesDD['small-text-bold-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['small-text-bold-eng'].letterSpacing,
                },
              ],
              subheading: [
                typographiesDD['d-sub-heading-eng'].fontSize,
                {
                  lineHeight: typographiesDD['d-sub-heading-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-sub-heading-eng'].letterSpacing,
                },
              ],
              'subheading-mobile': [
                typographiesDD['d-sub-heading-eng'].fontSize,
                {
                  lineHeight: typographiesDD['d-sub-heading-eng'].lineHeight,
                  letterSpacing:
                    typographiesDD['d-sub-heading-eng'].letterSpacing,
                },
              ],
            },
          },
        },
      ],
    }),
  ],
  safelist: [
    'lg:text-left',
    'lg:text-right',
    'lg:text-center',
    'text-80-white-on-dark-blue',
    'text-40-white-on-dark-blue',
    'text-progressive-blue',
    'text-natural-cream',
    'text-10-black-on-natural-cream',
    'text-light-grey-1',
    'text-light-grey-2',
    'text-body-text-grey',
    'text-off-black',
    'opacity-0',
    'opacity-10',
    'opacity-15',
    'fill-warm-grey',
    'fill-warm-grey/15',
  ],
};
